import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isDevelopment } from '@ibk/shared-config';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { sharedUiTranslations } from '../../translations';
import ProfileMenuItem from '../ProfileMenuItem';
export const DEVELOPER_SETTINGS_PATH = '/configuracoes-desenvolvedor';
export const ProfileMenuDeveloperSettingsItemBase = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    if (!isDevelopment()) {
        return null;
    }
    return (_jsx(ProfileMenuItem, { title: t('profile-menu-item.developer-settings'), onClick: () => navigate(DEVELOPER_SETTINGS_PATH) }));
};
export const ProfileMenuDeveloperSettingsItem = () => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(ProfileMenuDeveloperSettingsItemBase, {}) }));
};
export default ProfileMenuDeveloperSettingsItem;
